import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1307Component } from './kymw1307.component';
import { GetSummaryTableService } from './api-services/get-summary-table.service';


/**
 * 予算・計画・実績表画面 モジュール設定クラス
 *
 * @export KYMW1307Module
 * @class KYMW1307Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1307Component,
  ],
  providers: [
    GetSummaryTableService,
  ],
})
export class KYMW1307Module {
}
